import { memo } from 'react';

import { TAiSimulationPartialDto } from '@app-velocity/av-api-v2';

import { useReportContext } from '../../context/useReportContext';

export type ViewPreviewProps = {
  pageId: string;
  partials: TAiSimulationPartialDto[];
  clicks?: { x: number; y: number }[];
  size: 'full' | 'large' | 'normal';
  persona: 'accessible' | 'default' | string;
  width?: number;
  height?: number;
  image?: string;
  highlight?: boolean;
};

const getSize = (size: 'full' | 'large' | 'normal') => {
  switch (size) {
    case 'full':
      return document.body.offsetHeight - 100;
    case 'large':
      return 500;
    default:
      return 250;
  }
};

export const ViewPreview = memo(
  ({
    pageId,
    partials,
    clicks,
    size,
    persona,
    image,
    width,
    height,
    highlight,
  }: ViewPreviewProps) => {
    const { renderStepView } = useReportContext();

    const targetHeight = getSize(size);

    return renderStepView(
      pageId,
      partials,
      clicks || [],
      size,
      targetHeight,
      persona,
      image,
      width,
      height,
      highlight
    );
  }
);
